import React from "react";
import { ArrowUpRight, ArrowDownRight, Lock, CheckCircle2 } from "lucide-react";
import { fmtPrice } from "./ZoneVisualizer";
import { computeProximity, proximityLabel, proximityColor } from "../lib/proximity";

export default function AssetWatchlist({ setups, selectedId, onSelect }) {
  if (!setups || setups.length === 0) {
    return (
      <div className="p-3 text-xs text-zinc-600 italic">Keine Treffer.</div>
    );
  }

  return (
    <div className="divide-y divide-zinc-900" data-testid="asset-watchlist">
      {setups.map((s) => {
        const ch = s.day_change_percent;
        const chColor = ch == null ? "text-zinc-500" : ch > 0 ? "text-emerald-400" : ch < 0 ? "text-rose-400" : "text-zinc-400";
        const isLong = s.direction === "long";
        const DirIcon = isLong ? ArrowUpRight : ArrowDownRight;
        const dirColor = isLong ? "text-emerald-500" : "text-rose-500";
        const closed = s.status === "closed";
        const isSelected = selectedId === s.id;
        const prox = computeProximity(s);
        const proxLbl = proximityLabel(prox);

        return (
          <button
            key={s.id}
            onClick={() => onSelect(s.id)}
            data-testid={`watchlist-item-${s.id}`}
            className={`w-full text-left px-3 py-2.5 transition-colors hover:bg-zinc-900/60 ${
              isSelected ? "bg-zinc-900 border-l-2 border-emerald-500" : "border-l-2 border-transparent"
            }`}
          >
            {/* Row 1: Asset name + price (BIG, easy to read) */}
            <div className="flex items-center justify-between gap-2 leading-none">
              <div className="flex items-center gap-1.5 min-w-0">
                <DirIcon size={13} className={`${dirColor} shrink-0`} strokeWidth={2.5} />
                <span className="font-display font-bold text-[15px] truncate">{s.asset_name}</span>
                {s.is_attractive_now && (
                  <CheckCircle2 size={12} className="text-emerald-400 shrink-0" title="Aktuell attraktiv laut Friedrich" />
                )}
                {closed && <Lock size={11} className="text-zinc-600 shrink-0" />}
              </div>
              <span className="font-mono-num font-bold text-[14px] text-white shrink-0">
                {s.last_price != null ? fmtPrice(s.last_price) : "—"}
              </span>
            </div>
            {/* Row 2: Symbol + day change */}
            <div className="flex items-center justify-between text-[11px] font-mono-num mt-1.5">
              <div className="flex items-center gap-1 min-w-0 truncate">
                <span className="text-zinc-500 truncate text-[10px]">{s.symbol}</span>
                {proxLbl && (
                  <span
                    className={`px-1 py-px border text-[8px] font-display font-bold uppercase tracking-wider rounded-sm ${proximityColor(prox)}`}
                    data-testid={`prox-${s.id}`}
                  >
                    {proxLbl}
                  </span>
                )}
              </div>
              <span className={`${chColor} font-bold`} title="Tagesveränderung">
                {ch != null ? `${ch > 0 ? "+" : ""}${ch.toFixed(2)}%` : "—"}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
